import { z } from 'zod'

export const caseAlertFormSchema = z.object({
  alertType: z.string().optional(),
  alertDate: z.date().optional(),
  notificationSettings: z
    .object({
      count: z.string().optional(),
      unit: z.string().optional(),
    })
    .optional(),
})

export const caseAlertFormSchemaRequired = z.object({
  alertType: z.string(),
  alertDate: z.date(),
  notificationSettings: z.object({
    count: z.string(),
    unit: z.string(),
  }),
})
